var template = `
<svg fill="none" height="32" stroke="#ccc" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><rect height="20" rx="2" ry="2" transform="rotate(180 12 12)" width="16" x="4" y="2"/></svg>
`;

export default {
    template: template
};
